export const Export2Doc = (element, filename = '') => {
  let preHtml =
    "<html><head><meta charset='utf-8'><title>LivDemy</title></head><body>"
  let postHtml = '</body></html>'
  let html = preHtml + document.getElementById(element).innerHTML + postHtml

  let blob = new Blob(['\ufeff', html], {
    type: 'text/html',
  })

  // Specify link url
  let url = 'data:text/html;charset=utf-8,' + encodeURIComponent(html)

  // Specify file name
  filename = filename ? filename + '.html' : 'notes.html'

  // Create download link element
  let downloadLink = document.createElement('a')

  document.body.appendChild(downloadLink)

  if (navigator.msSaveOrOpenBlob) {
    navigator.msSaveOrOpenBlob(blob, filename)
  } else {
    // Create a link to the file
    downloadLink.href = url

    // Setting the file name
    downloadLink.download = filename

    //triggering the function
    downloadLink.click()
  }

  document.body.removeChild(downloadLink)
}
